class faqService {
  /**
   * Get paginated FAQ list (parents or children). Response: { data: [], total, page, limit, totalPages }.
   * @param {string} [query] - Query string, e.g. "page=1&limit=10" or "key=<parentId>&page=1&limit=10" for children
   */
  async getFaqByEntity(query) {
    const baseUrl = useRuntimeConfig().public.API_URL + "/get-equirize-faq";
    const url = query ? `${baseUrl}?key=${encodeURIComponent(query)}` : baseUrl;
    const response = await $fetch(url, {
      headers: { "Content-Type": "application/json" },
      method: "GET",
    });
    return response;
  }

  /**
   * Get all FAQs (paginated). Response: { data: [], total, page, limit, totalPages }.
   * @param {string} [query] - Optional "page=1&limit=10"
   */
  async getAllFaqs(query = "") {
    const baseUrl = useRuntimeConfig().public.API_URL + "/get-equirize-faq";
    const url = query ? `${baseUrl}?${query}` : baseUrl;
    const response = await $fetch(url, {
      headers: { "Content-Type": "application/json" },
      method: "GET",
    });
    return response;
  }
}

export default new faqService();